module.exports = require('../_components/@alicd/next-range/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/range/index.js
// module id = 655
// module chunks = 0